import React, { useEffect, useRef, useState } from 'react'
import axios from '../../API/axios';
import JobList from './JobList';
import SearchHeader from './SearchHeader';
import JobFilter from './JobFilter';
import { header } from "../../config/imagesLink";
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const JobSearch = () => {

    const scrollContainerRef = useRef();
    const { t } = useTranslation();
    const sessionId = localStorage.getItem("sessionId");
    const guestModeData = localStorage.getItem("guestMode");
    const userUid = localStorage.getItem("userUid");
    const [filterJobList, setFilterJobList] = useState([]);
    const [country, setCountry] = useState([]);
    const [selectedCountryData, setSelectedCountryData] = useState([]);
    const [city, setCity] = useState([]);
    const [selectedCity, setSelectedCity] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompanyData, setSelectedCompanyData] = useState([]);
    const [designationList, setDesignationList] = useState([]);
    const [selectedDesignationData, setSelectedDesignationData] = useState([]);
    const [selectedJobTypeData, setSelectedJobTypeData] = useState([]);
    const [jobTypeList, setJobTypeList] = useState([]);
    const [salaryTypeList, setSalaryTypeList] = useState([]);
    const [selectedSalaryType, setSelectedSalaryType] = useState([]);
    const [selectedWorkLevel, setSelectedWorkLevel] = useState([]);
    const [workLevelTypeList, setWorkLevelTypeList] = useState([]);
    const [workLocationType, setWorkLocationTypeList] = useState([]);
    const [selectedWorkLocation, setSelectedWorkLocationList] = useState([]);
    const ProfilePercent = localStorage.getItem("ProfilePercentage"); 

    //************************ jobs list Start  ************************//
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [jobsList, setJobsList] = useState([]);
    const [searchjobsList, setSearchJobsList] = useState([]);
    const [isError, setIsError] = useState(false);
    const [reset, setReset] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [hasMoreData, setHasMoreData] = useState(true);
    const [nextBatchLoading, setNextBatchLoading] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState(searchValue);

    const getAllJobList = (page) => {
        setNextBatchLoading(true);
        const data = {
            // search: searchValue,
            search: debouncedSearch,
            countryIDs: selectedCountryData,
            cityIDs: selectedCity,
            companyIDs: selectedCompanyData,
            jobtypeIDs: selectedJobTypeData,
            workLevelTypeIDs: selectedWorkLevel,
            workLocationTypeIDs: selectedWorkLocation,
            salaryTypeIDs: selectedSalaryType,
            designationIDs: selectedDesignationData,
            skillIDs: [],
            deviceType: "Web",
            pageNumber: page,
            pageSize: 12
        } 
        axios
            .post(`Job/GetJobsWithFilters`, data)
            .then((response) => {
                console.log("dasasasa", response);
                
                setIsLoading(true);

                 if(response.status===204){
                    setIsError(true); 
                }else{   
                setIsError(false);
                setTotalPages(response.data.responseData.paging.totalPages);
                setCountry(response.data.responseData.filters.countryList || []);
                setCity(response.data.responseData.filters.cityList || []);
                setCompanyList(response.data.responseData.filters.companyList || []);
                setDesignationList(response.data.responseData.filters.designationList || []);
                setJobTypeList(response.data.responseData.filters.jobTypeList || []);
                setSalaryTypeList(response.data.responseData.filters.salaryTypeList || []);
                setWorkLevelTypeList(response.data.responseData.filters.workLevelTypeList || []);
                setWorkLocationTypeList(response.data.responseData.filters.workLocationTypeList || []);
                let newPosts = response.data.responseData.jobs || [];
                
                    setJobsList(prev => {
                    // setIsLoading(false);
    
                        if (reset) {
                            setReset(false);
                            console.log("jobsss",newPosts);
                            return newPosts;
    
                        } else {
                            const postSet = new Set(prev.map(p => p.jobId));
                            const uniqueNewPosts = newPosts.filter(p => !postSet.has(p.jobId));
                    // console.log("jobsss",uniqueNewPosts);
    
                            return [...prev, ...uniqueNewPosts];
                            
                    // page === 1 ? res : [...prev, ...res]
                        }
                    });
                    setIsLoading(false); 
                }

                if (page >= response.data.responseData.paging.totalPages) {
                    // setHasMoreData(false);
                    setHasMoreData(page < totalPages);

                } else {
                    setHasMoreData(true);
                }
                setNextBatchLoading(false);
            }
            )
            .catch((error) => {
                if (error.response && error.response.status === 404) {
                    setIsError(true);
                } else {
                    console.log(error);
                }
                setIsLoading(false);
                setNextBatchLoading(false);
            });
    };
   

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchValue);
        }, 1000); // 500ms pause ke baad update hoga

        return () => clearTimeout(timer);
    }, [searchValue]);
    useEffect(() => {
        // if (page > 1  && hasMoreData) {
            if (page > 1 && !reset && hasMoreData) {
                getAllJobList(page);
            }
        }, [page]);

    useEffect(() => {
        setPage(1);
        setHasMoreData(true);
        getAllJobList(1);
        setJobsList([]);
        // setReset(true);
    }, [
        debouncedSearch,
        // searchValue,
        selectedCountryData,
        selectedCity,
        selectedCompanyData,
        selectedDesignationData,
        selectedJobTypeData,
        selectedSalaryType,
        selectedWorkLocation,
        selectedWorkLevel 

    ]);

    const handleInfiniteScroll = () => {
        if (
            window.innerHeight + window.scrollY >= document.body.scrollHeight - 100 &&
            !nextBatchLoading &&
            hasMoreData &&
            !isLoading &&
            !reset
        ) {
            setPage((prev) => prev + 1);
        }
    };

    //************************ jobs list End  ************************//

    const [alert, setAlert] = useState(false);
    const [isLoadingalert, setIsLoadingalert] = useState(true); // Add loading state

    const normalizedUserPer = Array.isArray(ProfilePercent) ? (ProfilePercent.length === 0 ? 0 : Number(ProfilePercent[0])) : Number(ProfilePercent);

    const shouldShowAlert = !isLoadingalert || normalizedUserPer <= 59 && alert === false && guestModeData === null;

    const adInitialized = useRef(false);

     useEffect(() => {
        // Dynamically add the adsbygoogle script
        const script = document.createElement("script");
        script.async = true;
        script.src =
            "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8691062301030113";
        script.crossOrigin = "anonymous";
        document.body.appendChild(script);

        // Initialize the ad
        if (!adInitialized.current) {
            window.adsbygoogle = window.adsbygoogle || [];
            window.adsbygoogle.push({});
            adInitialized.current = true;
        }

        // Add event listener to open ads in a new tab
        const handleAdClick = (event) => {
            const target = event.target;
            if (target.tagName === "A" && !target.hasAttribute("target")) {
                target.setAttribute("target", "_blank");
            }
        };

        // Attach listener to the entire document for dynamic ads
        document.addEventListener("click", handleAdClick);

        return () => {
            // Cleanup script and listener on component unmount
            document.body.removeChild(script);
            document.removeEventListener("click", handleAdClick);
        };
    }, []); 


    useEffect(() => {
        window.addEventListener("scroll", handleInfiniteScroll);
        return () => window.removeEventListener("scroll", handleInfiniteScroll);
    }, []);
    
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <>
            <Helmet>
                <title>Search Job | Welinkjobs </title>
                <meta name="description" content="Unleash your job search potential with Welinkjobs. Explore opportunities on the most trusted job search sites and find your dream job." />
                {/* <meta name="keywords" content="react, meta tags, seo" /> */}
                {/* <meta name="author" content="Your Name" /> */}
                <meta property="og:title" content="Find Your Next Opportunity: Welinkjobs Jobs Search" />
                <meta property="og:description" content="Unleash your job search potential with Welinkjobs. Explore opportunities on the most trusted job search sites and find your dream job." />
                {/* <meta property="og:image" content="https://example.com/image.jpg" /> */}
                <meta property="og:url" content="https://welinkjobs.com/SearchJob" />
            </Helmet>
            <div className="p-lg-5 p-md-2 p-2 mt-5 PaddingTop padding-bottom">
                {shouldShowAlert && (
                    <div className='p-3 closeAccount m-0 mb-3 mt-1'>
                        <div className='d-flex mb-3 align-items-center'>
                            <InfoSharpIcon />
                            <span className='cardHeader ms-1'>{t("Newsfeed.Announcement")} </span>
                            <span className="ms-auto">
                                <CloseSharpIcon
                                    style={{ width: '20px' }}
                                    className="pointer"
                                    onClick={() => setAlert(true)} // Dismiss the alert
                                />
                            </span>
                        </div>
                        <div>
                            <span>{t("Newsfeed.Accounce")} </span>


                            <Link to={`/User/${userUid}`} className="border-bottom f-600 warn-resume">
                                {t("Newsfeed.Manage Profile")}
                                {/* Manage Profile */}
                            </Link>
                        </div>
                    </div>
                )}
                {/* {(guestModeData === 'false'|| guestModeData===null) && userPer <= 60 && alert === false && (
                    <div className='p-3 closeAccount m-0 mb-3'>
                        <div className='d-flex mb-3 align-items-center'>
                            <InfoSharpIcon />
                            <span className='cardHeader ms-1'>Announcement!</span>
                            <span className="ms-auto">
                                <CloseSharpIcon style={{ width: '20px' }} className="pointer" onClick={() => {
                                    setAlert(true);
                                }} />
                            </span>
                        </div>
                        <div>
                            <span>Applying for a new job ! Update your profile and resume Now.</span>

                        </div>
                        <div className=" mt-2">
                    <Link to={`/User/${userUid}`}>
                       <button
                          color=""
                           className="closebtn"
                             style={{ width: "150px" }}  >
                        Manage Profile
                      </button>
                    </Link>
                </div>
                    </div>)} */}
                <div className="advertiseImage">
                    {/* <img src={NewsFeed.Advertise} alt="" /> */}
                    <div className="advertisementview mb-2">
                        <div className="advertisementContainer" style={{
                            width: "100%",
                            height: "180px", // Set a fixed height
                            overflow: "hidden", // Prevent overflow issues
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',

                        }}>
                            <ins className="adsbygoogle"
                                style={{
                                    display: "block",
                                    width: "100%",
                                    height: "100%", // Ensure it fits the container
                                    // maxWidth: "320px",
                                    // minHeight: "50px",
                                    margin: "0 auto",
                                }}
                                data-ad-client="ca-pub-8691062301030113"
                                data-ad-slot="9135916775"
                                // data-ad-format="auto"
                                data-adtest="on"
                                data-full-width-responsive="true"></ins>
                        </div>
                        {/* <h1 className="adText">Advertisement</h1> */}
                    </div>

                </div>
                <SearchHeader
                    country={country || []}
                    city={city || []}
                    companyList={companyList || []}
                    designationList={designationList || []}
                    selectedCountryData={selectedCountryData || []}
                    setSelectedCountryData={setSelectedCountryData || []}
                    selectedCity={selectedCity || []}
                    setSelectedCity={setSelectedCity || []}
                    selectedCompanyData={selectedCompanyData || []}
                    setSelectedCompanyData={setSelectedCompanyData || []}
                    selectedDesignationData={selectedDesignationData || []}
                    setSelectedDesignationData={setSelectedDesignationData || []}
                    setReset={setReset}
                />
                <div className="row jobMainContainer">
                    <div className="col-lg-3 col-md-4">
                        <JobFilter
                            setJobsList={setJobsList}
                            jobsList={jobsList}
                            setSelectedJobTypeData={setSelectedJobTypeData || []}
                            jobTypeList={jobTypeList || []}
                            salaryTypeList={salaryTypeList || []}
                            setSelectedSalaryType={setSelectedSalaryType || []}
                            workLevelTypeList={workLevelTypeList || []}
                            setSelectedWorkLevel={setSelectedWorkLevel || []}
                            workLocationType={workLocationType || []}
                            setSelectedWorkLocationList={setSelectedWorkLocationList || []}
                            setReset={setReset}
                        />
                        <div className="advertiseImage">
                            {/* <img src={NewsFeed.Advertise} alt="" /> */}
                            <div className="advertisementview">
                                <div className="advertisementContainer" style={{
                                    width: "100%",
                                    height: "200px", // Set a fixed height
                                    overflow: "hidden", // Prevent overflow issues
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <ins className="adsbygoogle"
                                        style={{
                                            display: "block",
                                            width: "100%",
                                            height: "100%", // Ensure it fits the container
                                            // maxWidth: "320px",
                                            // minHeight: "50px",
                                            margin: "0 auto",
                                        }}
                                        data-ad-client="ca-pub-8691062301030113"
                                        data-ad-slot="9135916775"
                                        // data-ad-format="auto"
                                        data-adtest="on"
                                        data-full-width-responsive="true"></ins>
                                </div>
                                <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
                            </div>

                        </div>
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <JobList
                            refContainer={scrollContainerRef}
                            jobsList={jobsList}
                            setJobsList={setJobsList}
                            setSearchValue={setSearchValue}
                            searchValue={searchValue}
                            isLoading={isLoading}
                            isError={isError}
                            page={page}
                            getAllJobList={getAllJobList}
                            totalPages={totalPages}
                            setTotalPages={setTotalPages}
                            setReset={setReset}
                            filterJobList={filterJobList}
                            reset={reset}
                            nextBatchLoading={nextBatchLoading}
                            hasMoreData={hasMoreData}
                        />
                    </div>
                    {/* <div className="col-md-2">
                        <div className="jobList py-3 text-center desktopView">
                            <img src={header.ad1} alt="" width={"100%"} />
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default JobSearch